import { formatEuro } from 'Containers/Statistic/containers/StatisticNew/layout-category-shades/mockData';

const toNumber = (value) => {
  if (value === undefined || value === null || value === '') return null;
  const n = Number(value);
  return Number.isFinite(n) ? n : null;
};

const pickNumber = (homeStat, keys) => {
  for (const key of keys) {
    const n = toNumber(homeStat?.[key]);
    if (n != null) return n;
  }
  return null;
};

const formatDeltaPct = (pct) => {
  if (pct == null) {
    return { value: false, isPercent: false, positive: false };
  }

  return {
    value: `${pct.toFixed(0)}%`,
    isPercent: true,
    positive: pct >= 0,
  };
};

const formatMoneyOrDash = (amount) => (amount == null ? '—' : formatEuro(amount));

const formatScopeDelta = (delta) => {
  if (!delta || delta.pct === undefined || delta.pct === null) {
    return { value: false, isPercent: false, positive: false };
  }

  return {
    value: `${delta.pct}%`,
    isPercent: true,
    positive: delta.direction === 'up',
  };
};

export const hasHomeStatMoneyInsights = (values) =>
  Array.isArray(values) && values.some((row) => row?.count && row.count !== '—' && row.count !== '…');

/** Stesso insight, da /statistiche/v3/finance (solo dopo tap in Home). */
export const buildDailyPerformanceInsightsFromScope = (scope, t) => {
  if (!scope) return [];

  const deltaHint = t('home.infoCards.performance.deltaVsYesterday');

  return [
    {
      id: 'revenue',
      title: t('home.infoCards.performance.revenue'),
      count: formatEuro(scope.fatturato ?? 0),
      ...formatScopeDelta(scope.deltas?.fatturato),
      infoDescription: t('home.infoCards.performance.revenueInfo'),
      deltaHint,
    },
    {
      id: 'avgTicket',
      title: t('home.infoCards.performance.avgTicket'),
      count: formatEuro(scope.scontrinoMedio ?? 0),
      ...formatScopeDelta(scope.deltas?.scontrinoMedio),
      infoDescription: t('home.infoCards.performance.avgTicketInfo'),
      deltaHint,
    },
    {
      id: 'profit',
      title: t('home.infoCards.performance.profit'),
      count: formatEuro(scope.utile ?? 0),
      ...formatScopeDelta(scope.deltas?.utile),
      infoDescription: t('home.infoCards.performance.profitInfo'),
      deltaHint,
    },
  ];
};

/**
 * Insight giornalieri dalla sola getHomeStat (niente /statistiche/v3 in Home).
 * Accetta alias se il BE li aggiunge all'endpoint già cacheato.
 */
export const buildDailyPerformanceInsights = (homeStat, t) => {
  if (!homeStat || !Object.keys(homeStat).length) return [];

  const fatturato = pickNumber(homeStat, [
    'fatturatoOggi',
    'fatturatoToday',
    'incassoOggi',
    'allFatturatoToday',
    'incassoToday',
    'fatturato',
  ]);
  const scontrino = pickNumber(homeStat, [
    'scontrinoMedioOggi',
    'scontrinoMedioToday',
    'avgTicketToday',
    'scontrinoMedio',
    'avgTicket',
  ]);
  const utile = pickNumber(homeStat, [
    'utileOggi',
    'utileNettoOggi',
    'utileToday',
    'utileNetto',
    'utile',
  ]);

  const prenToday = toNumber(homeStat.allPrenToday);
  const scontrinoResolved =
    scontrino != null
      ? scontrino
      : fatturato != null && prenToday > 0
        ? fatturato / prenToday
        : null;

  const deltaHint = t('home.infoCards.performance.deltaVsYesterday');

  return [
    {
      id: 'revenue',
      title: t('home.infoCards.performance.revenue'),
      count: formatMoneyOrDash(fatturato),
      ...formatDeltaPct(
        pickNumber(homeStat, ['diffFatturatoOggi', 'diffFatturatoToday', 'diffIncassoOggi', 'diffFatturato']),
      ),
      infoDescription: t('home.infoCards.performance.revenueInfo'),
      deltaHint,
    },
    {
      id: 'avgTicket',
      title: t('home.infoCards.performance.avgTicket'),
      count: formatMoneyOrDash(scontrinoResolved),
      ...formatDeltaPct(
        pickNumber(homeStat, ['diffScontrinoMedioOggi', 'diffScontrinoMedio', 'diffAvgTicket']),
      ),
      infoDescription: t('home.infoCards.performance.avgTicketInfo'),
      deltaHint,
    },
    {
      id: 'profit',
      title: t('home.infoCards.performance.profit'),
      count: formatMoneyOrDash(utile),
      ...formatDeltaPct(pickNumber(homeStat, ['diffUtileOggi', 'diffUtileToday', 'diffUtile'])),
      infoDescription: t('home.infoCards.performance.profitInfo'),
      deltaHint,
    },
  ];
};
